import { AppThunk } from 'src/store/ThunkTypes';

// Actions
import {
  overwriteCurrentQuotation,
  updateUsedLicense,
  updateQuotationModalIsOpen,
  updateCloningQuotationId,

  // The default "empty" value should have multiple options set to "true", as it is the default
  // value expected by the DynamicQuotationPage
  emptyQuotationWithMultipleOptions,
  updateUsedProfile,
  updateIsLicenseAutoPx,
  updateUsedAdditionalBroker,
  updateUsedSubAgentLicense,
} from 'src/store/quotation/slice/quotationSlice';

import { setCurrentCarGeneralData } from 'src/store/car/slice/carSlice';
import { setCurrentCustomer } from 'src/store/customer/slice/customerslice';
import { updateCurrentPage } from 'src/store/steppers/slice/steppersSlice';

// Models
import { makeEmptyCustomerItem } from 'src/models/helperTypes/CustomerItem';
import { makeEmpty as makeEmptyCarItem } from 'src/models/helperTypes/CarItem';

/**
 * Prevents stray values between creation attempts. The following attributes are set to their original
 * values:
 * - Current quotation is set to an "empty" variant
 * - Data from all creation forms are deleted
 * - Used license is set back to an empty string
 * - Used profile is set back to 0
 * - IsLicenseAutoPx flag is returned to default value
 * - Forcefully set the modal as "closed"
 * - Reset the stepper's offset to 0, so that the first page can be shown
 */
const resetCreationFormValues =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(
      overwriteCurrentQuotation({ ...emptyQuotationWithMultipleOptions }),
    );
    dispatch(setCurrentCarGeneralData(makeEmptyCarItem()));
    dispatch(setCurrentCustomer(makeEmptyCustomerItem()));
    dispatch(updateUsedLicense(''));
    dispatch(updateUsedProfile(0));
    dispatch(updateUsedAdditionalBroker([]));
    dispatch(updateIsLicenseAutoPx(false));
    dispatch(updateQuotationModalIsOpen(false));
    dispatch(updateCurrentPage(0));
    dispatch(updateCloningQuotationId(-1));
    dispatch(updateUsedSubAgentLicense(''));
  };

export default resetCreationFormValues;
